<template>
  <div>
    <a href="#" @click="mostrarInfo()" @click.prevent="cerrarPopUpInfo(true)">
      <div class="cuponAmigo codigoCupon">{{ cupon.cupon }}</div>
      <p v-if="cupon.pendiente" class="pure-button estadoCupon pendiente">
        Compartir
      </p>
      <p v-if="cupon.activado" class="pure-button estadoCupon activado">
        Activado
      </p>
      <p v-if="cupon.disponible" class="pure-button estadoCupon disponible">
        Asignar
      </p>
      <p v-if="cupon.asignado" class="pure-button estadoCupon asignado">
        Asignado
      </p>
      <p v-if="cupon.consumido" class="pure-button estadoCupon consumido">
        Consumido
      </p>
    </a>

    <InfoCuponAmigoPendiente
      v-if="popUpInfoPendiente"
      :cupon-inic="cupon"
      @closeInfoCuponAmigo="cerrarPopUpInfo(false)"
    />

    <InfoCuponAmigoActivado
      v-if="popUpInfoActivado"
      :cupon-inic="cupon"
      @closeInfoCuponAmigo="cerrarPopUpInfo(false)"
    />

    <InfoCuponAmigoDisponible
      v-if="popUpInfoDisponible"
      :cupon-inic="cupon"
      @closeInfoCuponAmigo="cerrarPopUpInfo(false)"
    />

    <InfoCuponAmigoAsignado
      v-if="popUpInfoAsignado"
      :cupon-inic="cupon"
      @closeInfoCuponAmigo="cerrarPopUpInfo(false)"
    />

    <InfoCuponAmigoConsumido
      v-if="popUpInfoConsumido"
      :cupon-inic="cupon"
      @closeInfoCuponAmigo="cerrarPopUpInfo(false)"
    />
  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      popUpInfoPendiente: false,
      popUpInfoActivado: false,
      popUpInfoDisponible: false,
      popUpInfoAsignado: false,
      popUpInfoConsumido: false,
    };
  },

  created() {
    console.log(this.cupon);
  },

  props: {
    cupon: {
      type: Object,
      required: true,
    },
  },

  methods: {
    mostrarInfo() {
      if (this.cupon.pendiente) {
        this.popUpInfoPendiente = true;
      }
      if (this.cupon.activado) {
        this.popUpInfoActivado = true;
      }
      if (this.cupon.disponible) {
        this.popUpInfoDisponible = true;
      }
      if (this.cupon.asignado) {
        this.popUpInfoAsignado = true;
      }
      if (this.cupon.consumido) {
        this.popUpInfoConsumido = true;
      }
    },
    cerrarPopUpInfo(val) {
      if (this.cupon.pendiente) {
        this.popUpInfoPendiente = val;
      }
      if (this.cupon.activado) {
        this.popUpInfoActivado = val;
      }
      if (this.cupon.disponible) {
        this.popUpInfoDisponible = val;
      }
      if (this.cupon.asignado) {
        this.popUpInfoAsignado = val;
      }
      if (this.cupon.consumido) {
        this.popUpInfoConsumido = val;
      }
    },
    getEstado() {
      let cuponLowercase = this.cupon.estado.toLowerCase();
      return cuponLowercase.charAt(0).toUpperCase() + cuponLowercase.slice(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.cuponAmigo {
  display: inline-block;
  margin-right: 0.5rem;
  background-color: white;
  font-weight: bold;
  color: $azulOscuroMMT;
}

.estadoCupon {
  font-weight: bold;
  border-radius: 0.5rem;
  border: white solid;
  color: white;
  text-align: center;
  width: 7.5rem;
  height: 2.5rem;
  line-height: 2rem;
  padding: 0px;
}

.pendiente {
  background-color: $colorMMT;
}

.activado {
  background-color: #006600;
}

.disponible {
  background-color: #009999;
}

.asignado {
  background-color: #0000cc;
}

.consumido {
  background-color: #cccc00;
}

.codigoCupon {
  width: 10rem;
  border-radius: 0.5rem;
  border: $azulOscuroMMT 0.15rem solid;
  text-align: center;
}

.botonInfo {
  color: darkblue;
  font-size: 1.4rem;
  margin-right: 0.5rem;
}
</style>
